import type { FunctionComponent } from "react";
import {
  Text,
  CopyContent,
  Button,
  Loader,
} from "@kanda-libs/ks-design-library";
import {
  COPIED_BUTTON_PROPS,
  COPY_BUTTON_PROPS,
} from "components/company/CompanyLayout/CompanyDetails/Company/Director/constants";
import useDirectorProps from "components/company/CompanyLayout/CompanyDetails/Company/Director/useDirectorProps";
import { FormattedDirector } from "../../helpers";
import DirectorInfo from "./DirectorInfo";
import { UserType } from "@kanda-libs/ks-frontend-services";
import CompanyReportButton from "../../CompanyReportButton";

export interface DirectorProps {
  directors?: FormattedDirector[];
  users?: UserType[];
  isSubmitting?: boolean;
}

const Director: FunctionComponent<DirectorProps> = function ({
  directors = [],
  users = [],
}) {
  const {
    generateUrl,
    onClick,
    isSubmitting,
    editingIndex,
    setEditingIndex,
    onEditDirector,
  } = useDirectorProps();

  return (
    <div className="flex flex-col">
      {directors.map((director, key) => (
        <div
          key={director?.email}
          className="flex flex-col p-2 mb-4 border rounded-lg border-neutral-300 last:mb-0"
        >
          <div className="mb-2">
            <DirectorInfo
              onEdit={onEditDirector}
              index={key}
              director={director}
              user={users[key]}
              editing={editingIndex === key}
            />
          </div>
          {editingIndex !== key && (
            <span className="mb-2">
              <Button.Text
                id="staff-edit-director"
                variant="outline"
                label="Edit director details"
                onClick={() => {
                  setEditingIndex(key);
                }}
              />
              <CompanyReportButton user={users[key]} />
            </span>
          )}
          {director?.status === "verified" ? (
            <Text
              text="User is verified"
              className="text-green-500 text-14-22-em"
            />
          ) : (
            <>
              <CopyContent
                content={generateUrl(director)}
                clickedView={<Button.Link {...COPIED_BUTTON_PROPS} size={14} />}
              >
                <Button.Link {...COPY_BUTTON_PROPS} size={14} />
              </CopyContent>
              <Button.Text
                id="verify-user"
                onClick={() => onClick(director?.email)}
                label="Verify user"
                size={40}
                disabled={isSubmitting}
                className="mt-3"
              />
            </>
          )}
        </div>
      ))}
      <Loader isLoading={isSubmitting} />
    </div>
  );
};

export default Director;
